<template>
  <div>
    <v-snackbar
    color="error"
    top
    v-model="snackbar"
    :timeout="5000"
    >
      <v-row>
      {{text}}
      <v-spacer></v-spacer>
      <v-btn
        dark
        icon
        @click="snackbar = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      </v-row>
    </v-snackbar>
    <!-- radio group  -->
    <v-form v-model="valid" ref="flightForm">
      <v-row no-gutters class="mb-5">
        <v-col cols="12" sm="4">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="blueDark"
                dark
                text
                v-bind="attrs"
                v-on="on"
              >
                {{flightType === 'one' ? 'One Way Trip' : (flightType === 'round' ? 'Round Trip' : 'Multi City')}}
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="flightType = 'round';">
                <v-list-item-title>Round Trip</v-list-item-title>
              </v-list-item>
              <v-list-item @click="flightType = 'one';">
                <v-list-item-title>One Way</v-list-item-title>
              </v-list-item>
              <v-list-item @click="flightType = 'multi';">
                <v-list-item-title>Multi city</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="4" class="text-sm-center">
          <passengers/>
        </v-col>
        <v-col cols="12" sm="4" class="text-sm-right">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
              color="blueDark"
              dark
              text
              v-bind="attrs"
              v-on="on"
              >
                {{$store.state.passengers.classType.text }}
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in classes"
                :key="index"
                @click="setClass(item);"
              >
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <!-- inputs section -->
      <v-row no-gutters>
        <v-col cols="12" md="3">
          <cities @error="snackbar = true; text='Something went wrong'" type="Departure"></cities>
        </v-col>
        <v-col cols="12" md="3">
          <!-- @setSecondDeparture="setSecondDeparture" -->
          <cities @error="snackbar = true; text='Something went wrong'" type="Arrival"></cities>
        </v-col>
        <v-col cols="12" md="6" class="px-1">
          <v-row>
            <v-col cols="12" md="6">
              <picker key="return" v-if="flightType === 'round'" type="Departure Date"></picker>
            </v-col>
            <v-col cols="12" md="6">
              <picker key="return" v-if="flightType === 'round'" type="Arrival Date"></picker>
            </v-col>
          </v-row>
          <picker key="depart1" v-if="flightType === 'one' || flightType === 'multi'" type="Departure Date"></picker>
        </v-col>
      </v-row>

        <!-- second autocomplete components for multi -->
      <div v-if="flightType === 'multi'">
        <v-row no-gutters v-for="n in segments" :key="n">
          <v-col cols="12" md="3">
            <!-- :getSecondDeparture="secondDeparture" -->
            <cities @error="snackbar = true; text='Something went wrong'" type="multi-departure" :segment="n"></cities>
          </v-col>
          <v-col cols="12" md="3">
            <!--  @setThirdDeparture="setThirdDeparture" -->
            <cities @error="snackbar = true; text='Something went wrong'" type="multi-arrival" :segment="n"></cities>
          </v-col>
          <v-col cols="12" md="6" class="px-1 text-right">
            <picker key="depart2" type="multi" :segment="n"></picker>
          </v-col>
        </v-row>
      </div>

      <!-- third autocomplete components for multi -->
      <!-- <v-row no-gutters v-if="flightType === 'multi' && segments">
        <v-col cols="12" md="3">
          <cities @error="snackbar = true; text='Something went wrong'" type="Third Departure" :getThirdDeparture="thirdDeparture"></cities>
        </v-col>
        <v-col cols="12" md="3">
          <cities @error="snackbar = true; text='Something went wrong'" type="Third Arrival"></cities>
        </v-col>
        <v-col cols="12" md="6" class="px-1">
          <picker key="depart3" type="Third Departure Date"></picker>
        </v-col>
      </v-row> -->

      <!-- button for adding a travel segment -->
      <v-btn text color="success" v-if="flightType === 'multi' && segments < 5" class=" btn mb-5" @click="addSegment">
        <v-icon left>mdi-plus-circle</v-icon>
        Add a segment
      </v-btn>
      <!-- button for removing a travel segment -->
      <v-btn text color="error" v-if="flightType === 'multi' && segments > 1" class=" btn mb-5" @click="removeSegment">
        <v-icon left>mdi-close-circle</v-icon>
        Remove a segment
      </v-btn>

      <v-row>
        <v-col cols="12" md="3">
          <cities @error="snackbar = true; text='Something went wrong'" type="airline"></cities>
        </v-col>
        <v-col cols="12" md="3">
          <v-switch
          v-model="directFlights"
          inset
          label="Direct Flights"
          class="mx-5"
          color="success"
          ></v-switch>
        </v-col>

        <v-col cols="12" md="3">
          <v-autocomplete
          v-model="fareType"
          :items="[{text:'Net & Publish', value: null },{text: 'Net', value: 'net'}, {text: 'Publish', value: 'publish'}]"
          label="Fare Type"
          outlined
          class="mx-5"
          color="success"
          item-text="text"
          item-value="value"
          @change="setFareType"
          clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" class="text-right">
          <v-btn
          class="white--text rounded-lg px-10 mr-3"
          color="orange"
          height="52"
          @click="submit(false)"
          :loading="flightLoading"
          id="flights-search-submit"
          elevation="0"
          >
          search
          </v-btn>
        </v-col>
      </v-row>
        <v-row  v-if="$route.path === '/flightResults'" justify="end">
         <v-col cols="12" md="3" class="text-right">
          <div class="alt-search-wrapper">
            <v-btn
              color="blueDark"
              outlined
              large
              :loading="loadingAlternative"
              @click="submit(true)"
            >
              <v-icon left>mdi-calendar-range</v-icon>
              <div class="d-flex flex-column">
                <span>SEARCH ALTERNATIVE DATES</span>
                <small class="alt-note">
                 For Amadeus only
                </small>
              </div>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import cities from './citiesAutocomplete.vue'
import picker from './datePicker.vue'
import passengers from './passengersInfo'

export default {
  components: {
    cities,
    picker,
    passengers
  },
  props: ['flightLoading', 'loadingAlternative'],
  data () {
    return {
      flightType: 'round',
      fareType: null,
      isAlternativeDate: false,
      today: new Date().toISOString().substr(0, 10),
      size: '6',
      valid: true,
      secondDeparture: null,
      thirdDeparture: null,
      segments: 1,
      snackbar: false,
      text: '',
      color: '',
      classType: { text: 'Economy', value: 'Y' },
      classes: [
        { text: 'Economy', value: 'Y' },
        { text: 'Premium Economy', value: 'S' },
        { text: 'Business', value: 'C' },
        { text: 'First', value: 'F' }
      ],
      directFlights: false
    }
  },
  watch: {
    flightType (val) {
      if (val !== 'round') {
        this.size = '11'
      } else {
        this.size = '6'
      }
    }
  },
  computed: {
    tomorrow () {
      const tomorrow = new Date(this.today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow.toISOString().slice(0, 10)
    }
  },
  methods: {
    setClass (flightClass) {
      this.$store.dispatch('setPassengersClass', flightClass)
    },
    setSecondDeparture (value) {
      this.secondDeparture = value
    },
    setThirdDeparture (value) {
      this.thirdDeparture = value
    },
    addSegment () {
      this.segments++
      this.$store.dispatch('addSegment')
    },
    removeSegment () {
      this.segments--
      this.$store.dispatch('removeSegment')
      this.$refs.flightForm.resetValidation()
    },
    submit (isAlternative) {
      this.isAlternativeDate = isAlternative
      this.$refs.flightForm.validate()
      const searchStore = this.$store.state
      switch (this.flightType) {
        case 'multi':
          if (
            (
              this.flightType === 'multi' &&
              searchStore.airports.departureAirports.length === this.segments + 1 &&
              // searchStore.airports.departureAirports[1] &&
              // searchStore.airports.departureAirports[2] &&
              searchStore.airports.arrivalAirports.length === this.segments + 1 &&
              // searchStore.airports.arrivalAirports[1] &&
              // searchStore.airports.arrivalAirports[2] &&
              searchStore.flightDates.departureDates.length === this.segments + 1
              // searchStore.flightDates.departureDates[1] &&
              // searchStore.flightDates.departureDates[2]
            )
            // ||
            // (
            //   this.flightType === 'multi' &&
            //   !this.segments &&
            //   searchStore.airports.departureAirports[0] &&
            //   searchStore.airports.departureAirports[1] &&
            //   searchStore.airports.arrivalAirports[0] &&
            //   searchStore.airports.arrivalAirports[1] &&
            //   searchStore.flightDates.departureDates[0] &&
            //   searchStore.flightDates.departureDates[1]
            // )
          ) this.valid = true
          break
        case 'round':
          if (
            searchStore.airports.departureAirports[0] &&
            searchStore.airports.arrivalAirports[0] &&
            searchStore.flightDates.departureDates[0] &&
            searchStore.flightDates.arrivalDate
          ) this.valid = true
          break
        case 'one':
          if (searchStore.airports.departureAirports[0] &&
            searchStore.airports.arrivalAirports[0] &&
            searchStore.flightDates.departureDates[0]
          ) this.valid = true
          break
      }
      if (this.valid) {
        const searchParameters = {
          tripType: this.flightType
        }
        this.$store.dispatch('setType', this.flightType)
        let data = ''
        let string = ''
        if (!this.isSimilarAirpots()) {
          if (new Date(searchStore.flightDates.departureDates[0]).getTime() > new Date().getTime()) {
            if (new Date(searchStore.flightDates.departureDates[0]).getTime() <= new Date(searchStore.flightDates.arrivalDate).getTime() || this.flightType !== 'round') {
              switch (this.flightType) {
                case 'round':
                  // if (searchStore.airports.departureAirports[0] &&
                  //     searchStore.airports.arrivalAirports[0] &&
                  //     searchStore.flightDates.departureDates[0] &&
                  //     searchStore.flightDates.arrivalDate
                  // ) {
                  searchParameters.origin = searchStore.airports.departureAirports[0].Code
                  searchParameters.destination = searchStore.airports.arrivalAirports[0].Code
                  searchParameters.originType = searchStore.airports.departureAirports[0].Type
                  searchParameters.destinationType = searchStore.airports.arrivalAirports[0].Type
                  searchParameters.departureDate = searchStore.flightDates.departureDates[0]
                  searchParameters.arrivalDate = searchStore.flightDates.arrivalDate
                  searchParameters.classType = searchStore.passengers.classType.value
                  searchParameters.adults = searchStore.passengers.adults
                  searchParameters.children = searchStore.passengers.children
                  searchParameters.infants = searchStore.passengers.infants
                  if (searchStore.preferredAirline) searchParameters.preferredAirline = searchStore.preferredAirline.code
                  if (this.fareType) searchParameters.fareType = this.fareType.value
                  searchParameters.directFlights = this.directFlights ? 1 : 0
                  data = Object.entries(searchParameters).map(
                    ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                  ).join('&')
                  this.request(data)
                  // } else {
                  //   this.snackbar = true
                  //   this.color = 'error'
                  //   this.text = 'Please fill all fields'
                  // }
                  break
                case 'one':
                  searchParameters.origin = searchStore.airports.departureAirports[0].Code
                  searchParameters.destination = searchStore.airports.arrivalAirports[0].Code
                  searchParameters.originType = searchStore.airports.departureAirports[0].Type
                  searchParameters.destinationType = searchStore.airports.arrivalAirports[0].Type
                  searchParameters.departureDate = searchStore.flightDates.departureDates[0]
                  searchParameters.classType = searchStore.passengers.classType.value
                  searchParameters.adults = searchStore.passengers.adults
                  searchParameters.children = searchStore.passengers.children
                  searchParameters.infants = searchStore.passengers.infants
                  if (searchStore.preferredAirline) searchParameters.preferredAirline = searchStore.preferredAirline.code
                  if (this.fareType) searchParameters.fareType = this.fareType.value
                  searchParameters.directFlights = this.directFlights ? 1 : 0
                  data = Object.entries(searchParameters).map(
                    ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                  ).join('&')
                  this.request(data)
                  break
                case 'multi':
                  searchParameters.origin = searchStore.airports.departureAirports
                  searchParameters.destination = searchStore.airports.arrivalAirports
                  searchParameters.departureDate = searchStore.flightDates.departureDates
                  searchParameters.classType = searchStore.passengers.classType.value
                  searchParameters.adults = searchStore.passengers.adults
                  searchParameters.children = searchStore.passengers.children
                  searchParameters.infants = searchStore.passengers.infants
                  if (this.fareType) searchParameters.fareType = this.fareType.value
                  string = 'tripType=multi'
                  for (let i = 0; i < searchParameters.origin.length; i++) {
                    // if (i === 2 && searchParameters.origin[2] === null) {
                    //   continue
                    // }
                    console.log(searchParameters.origin[i], searchParameters.destination[i])
                    string += `&origin[]=${searchParameters.origin[i].Code}&originType[]=${searchParameters.origin[i].Type}&destination[]=${searchParameters.destination[i].Code}&destinationType[]=${searchParameters.destination[i].Type}&departureDate[]=${searchParameters.departureDate[i]}`
                  }
                  string += `&classType=${searchParameters.classType}&adults=${searchParameters.adults}&children=${searchParameters.children}&infants=${searchParameters.infants}`
                  string += `&directFlights=${this.directFlights ? 1 : 0}`
                  if (searchStore.preferredAirline) string += `&preferredAirline=${searchStore.preferredAirline.code}`
                  this.request(string)
                  break
                default:
                  break
              }
            } else {
              this.snackbar = true
              this.color = 'error'
              this.text = 'Please choose departure date before the arrival date you chose'
            }
          } else {
            this.snackbar = true
            this.color = 'error'
            this.text = 'Please choose departure date starting after today'
          }
        } else {
          this.snackbar = true
          this.color = 'error'
          this.text = 'Choose destinations different from origins'
        }
      } else {
        this.snackbar = true
        this.color = 'error'
        this.text = 'Please fill all fields'
      }
    },
    isSimilarAirpots () {
      const origins = this.$store.state.airports.departureAirports.filter(item => item !== null)
      const destinations = this.$store.state.airports.arrivalAirports.filter(item => item !== null)
      console.log('sim', origins, destinations)
      let isSimilar = false
      if (this.flightType === 'one' || this.flightType === 'round') {
        if (origins[0].Code === destinations[0].Code) isSimilar = true
      } else {
        for (let index = 0; index < origins.length; index++) {
          if (origins[index].Code === destinations[index].Code) isSimilar = true
        }
      }
      return isSimilar
    },
    request (data) {
      this.$store.dispatch('setFlightsTimeOut', false)
      this.$store.dispatch('setDirectFlights', this.directFlights)
      if (this.$store.state.flightsSearchTimeOutFunction !== null) this.$store.dispatch('clearFlightsSearchTimeoutFunction')
      if (this.$store.state.flightsTimeOutFunction !== null) this.$store.dispatch('clearFlightsTimeoutFunction')
      this.$store.dispatch('removeFlightResults')
      let path
      const searchStore = this.$store.state
      switch (this.flightType) {
        case 'one':
          path = `from=${searchStore.airports.departureAirports[0].Name}-to=${searchStore.airports.arrivalAirports[0].Name}`
          break
        case 'round':
          path = `from=${searchStore.airports.departureAirports[0].Name}-to=${searchStore.airports.arrivalAirports[0].Name}`
          break
        case 'multi':
          for (let i = 0; i < searchStore.airports.departureAirports.length; i++) {
            switch (i) {
              case 0:
                path = `from1=${searchStore.airports.departureAirports[0].Name}-to1=${searchStore.airports.arrivalAirports[0].Name}`
                break
              case 1:
                path += `&from2=${searchStore.airports.departureAirports[1].Name}-to2=${searchStore.airports.arrivalAirports[1].Name}`
                break
              case 2:
                if (searchStore.airports.departureAirports[2]) {
                  path += `&from3=${searchStore.airports.departureAirports[2].Name}-to3=${searchStore.airports.arrivalAirports[2].Name}`
                }
                break
            }
          }
          break
      }
      if (this.$route.name === 'flightResults') {
        this.$emit('addFlights', { data: data, isAlternativeDate: this.isAlternativeDate })
        this.$route.params.query = path
      } else this.$router.push({ name: 'flightResults', params: { term: data, query: path } })
    }
  },
  created () {
    if (this.$store.state.flightType === '') this.flightType = 'round'
    else this.flightType = this.$store.state.flightType
    if (this.$store.state.isDirectFlights) this.directFlights = this.$store.state.isDirectFlights
    this.segments = this.$store.state.airports.arrivalAirports.length > 1 ? this.$store.state.airports.arrivalAirports.length - 1 : 1
    // if (this.$route.name === 'flightResults' && !this.$store.state.airports.arrivalAirports[2]) this.segments = false
    this.classType = this.$store.state.passengers.classType
  }
}
</script>
<style>
.alt-search-wrapper {
  display: flex;
  flex-direction: column;
}

.alt-note {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}
</style>
